function FormFields() {


    // fields
    // name - matches the propterty name returned from API
    // types - how to render: text - input text; checkbox - checkbox, dictionary - dropdown, number - input number, datetime-local - date picker
    // display_name: label to show
    // read_only: not editable
    // dictionary - only for dictionary types - used for name of the dictionary from API. Name forms as dict_<dictionary>.toLowerCase()
    // value_field - "dictionary_value" or name of property in API (for example, "id") - used to map fields to API
    // null_value - value that should be send to API if the field is not populated (typically for numeric values)
    // dependant - used only for dictionary types. Specifies name of another field that is dependent on this value. Used by cascading dictionaries.
    //      - for example, when "parent" dictionary field changes it should clear the selected value in dependent field and re-populate depenent dropdown
    //          according to the selected parent value
    //          As of now building list depends on selected campus 
    // depends_on - used only for dictionary types. This is a reference back to "parent: dictionary name that dependent dictionary can use. 
    // show
    // show_in_list - true/false. If false this field will not be included in the list view of items
    // admin_only - true/false = show for users and admins or only for admins
    // required - true/false
    // required_group - name or id of the group of fields where at least one of the fields should be populated (for now - 2024-01-02 - used for Serial Number, Control Tag and Asset tag)
    const formFields = [
        {
            name: "last_name",
            type: "text",
            display_name: "Last Name",
            list_display_name: "Last Name",
            read_only: false,
            show: true,
            show_in_list: true,
            readonly_if_not_admin: true,
            admin_only: true,
            required: true,
            report: true,
        },
        {
            name: "first_name",
            type: "text",
            display_name: "First Name",
            list_display_name: "First Name",
            read_only: false,
            show: true,
            show_in_list: true,
            readonly_if_not_admin: true,
            admin_only: true,
            required: true,
            report: true,
        },
        {
            name: "employee_acct",
            type: "text",
            display_name: "Employee Account",
            list_display_name: "Employee Account",
            read_only: false,
            show: true,
            show_in_list: true,
            readonly_if_not_admin: true,
            admin_only: true,
            required: true,
            report: true,
        },
/*******
        {
            name: "is_lab",
            type: "checkbox",
            display_name: "Lab?",
            read_only: false,
            show: false,
            show_in_list: false,
            depends_on: "lab_name",
            admin_only: false,

        },

******/
        {
            name: "lab_name",
            type: "dictionary",
            display_name: "Lab",
            info:  "If not affiliated with a lab please select NOT APPLICABLE",
            list_display_name: "Lab",
            dictionary: "LAB",
            value_field: "dictionary_value",
            null_value: "",
            read_only: false,
            show: true,
            show_in_list: false,
            // dependant: "is_lab",
            admin_only: false,
            required: true,
            // lab_search: true,
            search: "by_lab",
            report: true,
        },


        // {
        //     name: "department_name",
        //     type: "text",
        //     display_name: "Department",
        //     read_only: false,
        //     show: true,
        // },
        {
            name: "campus",
            type: "dictionary",
            display_name: "Campus",
            list_display_name: "Campus",
            read_only: false,
            show: true,
            dictionary: "CAMPUS",
            value_field: "dictionary_value",
            null_value: "",
            dependant: "building_name",
            show_in_list: false,
            admin_only: false,
            required: true,
            // location_search: if true it's used in search by location
            location_search: true,
            search: "by_location",
            report: true,
        },
        {
            name: "building_name",
            type: "dictionary",
            display_name: "Building",
            list_display_name: "Building",
            read_only: false,
            show: true,
            dictionary: "BUILDING",
            value_field: "dictionary_value",
            null_value: "",
            depends_on: "campus",
            show_in_list: false,
            admin_only: false,
            required: true,
            // location_search: if true it's used in search by location
            location_search: true,
            search: "by_location",
            report: true,
        },
        {
            name: "floor",
            type: "dictionary",
            display_name: "Floor",
            list_display_name: "Floor",
            read_only: false,
            show: true,
            dictionary: "FLOOR",
            value_field: "dictionary_value",
            null_value: "",
            show_in_list: false,
            admin_only: false,
            required: false,
            report: true,
        },
        {
            name: "room_no",
            type: "text",
            display_name: "Room",
            list_display_name: "Room",
            read_only: false,
            show: true,
            show_in_list: false,
            report: true,
        },
        // {
        //     name: "physical_location",
        //     type: "text",
        //     display_name: "Physical Location",
        //     read_only: false,
        //     show: true,
        // },
        // {
        //     name: "location_name",
        //     type: "text",
        //     display_name: "Location",
        //     read_only: false,
        //     show: true,
        // },
        {
            name: "device_type",
            type: "dictionary",
            display_name: "Device Type",
            list_display_name: "Device Type",
            read_only: false,
            show: true,
            dictionary: "DEVICE_TYPE",
            value_field: "dictionary_value",
            null_value: "",
            show_in_list: true,
            admin_only: false,
            required: true,
            search: ["by_dev_type", "by_mass_certification"],
            report: true,
            dependant: "request_onsite_encryption_validation",
        },

        {
            name: "manufacturer",
            type: "text",
            display_name: "Manufacturer",
            list_display_name: "Manufacturer",
            read_only: false,
            show: true,
            show_in_list: true,
            admin_only: false,
            required: true,
            report: true,
        },
        {
            name: "model",
            type: "text",
            display_name: "Model",
            list_display_name: "Model",
            read_only: false,
            show: true,
            show_in_list: true,
            admin_only: false,
            required: false,
            report: true,
        },
        // the following 3 fields are in the same required_group - at least one of them should be populated
        {
            name: "serial_number",
            type: "text",
            display_name: "Serial Number",
            list_display_name: "Serial Number",
            read_only: false,
            show: true,
            show_in_list: true,
            admin_only: false,
            required: false,
            required_group: "1",
            report: true,
        },
        {
            name: "control_tag",
            type: "text",
            display_name: "Control Number",
            list_display_name: "Control Number",
            read_only: false,
            show: true,
            show_in_list: true,
            admin_only: false,
            required: false,
            required_group: "1",
            report: true,
        },
        {
            name: "asset_tag",
            type: "text",
            display_name: "Asset Tag or CD/DVD Count",
            // info: "For device type CD or DVD provide count information",
            list_display_name: "Asset Tag or CD/DVD Count",
            read_only: false,
            show: true,
            show_in_list: true,
            admin_only: false,
            required: false,
            required_group: "1",
            report: true,
        },
        
        {
            name: "encryption_technology",
            type: "dictionary",
            display_name: "Encryption Technology",
            list_display_name: "Encryption Technology",
            read_only: false,
            readonly_if_not_admin: true,
            show: true,
            dictionary: "ENCRYPTION_TYPE",
            value_field: "dictionary_value",
            null_value: "",
            show_in_list: true,
            admin_only: false,
            required: false,
            report: true,
        },

        {
            name: "device_status",
            type: "dictionary",
            display_name: "Current Status of Device",
            list_display_name: "Current Status of Device", //"Device Status",
            read_only: false,
            show: true,
            dictionary: "INVENTORY_STATUS",
            value_field: "dictionary_value",
            null_value: "",
            show_in_list: true,
            admin_only: false,
            required: true,
            // search: "by_dev_type",
            report: true,
            
        },

        

        {
            name: "comments",
            type: "textarea",
            display_name: "Additional Information",
            list_display_name: "Comments",
            read_only: false,
            show: true,
            show_in_list: false,
            admin_only: false,
            required: false,
            report: true,
            info: "If you have any questions send us email to ",
            mailto_text: "Mcldeviceinventory@mgb.org",
            mailto: "Mcldeviceinventory@mgb.org",
            
        },

        {
            name: "request_onsite_encryption_validation",
            type: "checkbox",
            display_name: "Request Onsite Encryption Verification",
            info: "Required only for Laptop - Other or Portable Drive unless image(s) provided",
            list_display_name: "Req. On-site Encr. Verification",
            read_only: false,
            show: true,
            show_in_list: false,
            depends_on: "device_type",
            admin_only: false,
            required: false,
            report: true,
        },

        {
            name: "initial_validation_by",
            type: "text",
            display_name: "Validation By",
            list_display_name: "Validation By",
            show: false,
            admin_only: true,
            show_in_list: false,
            report: true,
        },
        {
            name: "initial_validation_date",
            type: "datetime-local",
            display_name: "Validation Date",
            list_display_name: "Validation Date",
            show: false,
            admin_only: true,
            show_in_list: false,
            report: true,
        },
        // 2025-08-07 - ignore final valiadtion, we will use only one validation from now on and show it as Certification
        // {
        //     name: "final_validation_by",
        //     type: "text",
        //     display_name: "Final Validation By",
        //     list_display_name: "Final Validation By",
        //     show: false,
        //     admin_only: true,
        //     show_in_list: false,
        //     report: true,
        // },
        // {
        //     name: "final_validation_date",
        //     type: "datetime-local",
        //     display_name: "Final Validation Date",
        //     list_display_name: "Final Validation Date",
        //     show: false,
        //     admin_only: true,
        //     show_in_list: false,
        //     report: true,
        // },
        {
            name: "inventory_images",
            
            display_name: "Inventory Images",
            show: false,
            admin_only: false,
            show_in_list: false,
            report: true,
            type: "array",
            report_type: "array_count",
        },
        {
            name: "followup",
            type: "text",
            display_name: "Follow up",
            list_display_name: "Follow up",
            read_only: false,
            show: false,
            show_in_list: false,
            admin_only: true,
            required: false,
            report: false,
        },
        {
            name: "help_desk",
            type: "text",
            display_name: "Help Desk",
            list_display_name: "Help Desk",
            read_only: false,
            show: false,
            show_in_list: false,
            admin_only: true,
            required: false,
            report: false,
        },

       


    ]
        







    return formFields
}

export default FormFields
